import React, { Component } from 'react';
import { connect } from 'react-redux';
import RadioMenu from '../../../../common/RadioMenu/RadioMenu';

export const parseSearch = (search) => {
  const { subregion, region } = search;
  return {
    subregion: subregion
      ? subregion.split(',')
      : [],
    region: region
      ? region.split(',')
      : []
  };
};

export const compileSearch = (data) => {
  const { subregion, region } = data;
  return { subregion: subregion.length ? subregion.sort((a, b) => (a - b)).join(',') : undefined, region: region.length ? region.sort((a, b) => (a - b)).join(',') : undefined };
};

export const compileRequest = (data) => {
  const { subregion, region } = data;
  return { subregion: subregion.length ? subregion : undefined, region: region.length ? region : undefined };
};

export const getRequest = (search) => compileRequest(parseSearch(search));

class District extends Component {
  constructor(props) {
    super(props);

    this.state = {
      areas: []
    };

    this.handleCheckbox = this.handleCheckbox.bind(this);
  }

  componentDidMount() {
    const { areas } = this.props.cities.find(({ id }) => String(this.props.cityId) === String(id));
    this.setState({ areas });
  }

  handleCheckbox(keys) {
    const { dropdownData } = this.props;

    const regionIds = this.state.areas.reduce((acc, region) => {
      for (let i = 0; i < region.subareas.length; i++) {
        const subRegion = region.subareas[i];

        if (keys.includes(subRegion.id)) {
          acc.push(region.id);
        }
      }
      return [...new Set(acc)];
    }, []);

    const data = { subregion: keys, region: [...regionIds] };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  render() {
    const { search, className, objectType, profile, mode } = this.props;
    const { subregion, region } = parseSearch(search);
    const regionsMenu = this.state.areas.map((region) => ({
      regionId: region.id,
      tabText: region.name,
      checkboxes: region.subareas.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {})
    }));

    return regionsMenu.length > 0 &&
      <RadioMenu
        className={className}
        menus={regionsMenu}
        checked={subregion}
        handle={this.handleCheckbox}
        objectType={objectType}
        profile={profile}
        mode={mode}
      />;
  }
}

const mapStateToProps = (state) => ({
  cityId: state.profile.cityId,
  cities: state.building.cities
});

export default connect(mapStateToProps)(District);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/District/District.js